import type { CookieConsentConfig } from "vanilla-cookieconsent"

export const TRACKING_CATEGORY = "tracking"

export const consentConfig: CookieConsentConfig = {
  mode: "opt-in",
  autoShow: true,
  guiOptions: {
    // Accept and decline given equal visual weight — required for a valid
    // GDPR opt-in choice.
    consentModal: { layout: "box", equalWeightButtons: true },
    preferencesModal: { layout: "box", equalWeightButtons: true },
  },
  categories: {
    necessary: { enabled: true, readOnly: true },
    [TRACKING_CATEGORY]: {},
  },
  language: {
    default: "en",
    translations: {
      en: {
        consentModal: {
          title: "We value your privacy",
          description:
            "We use analytics and advertising cookies to understand how the site is used and to improve your experience. You can accept or decline these non-essential cookies.",
          acceptAllBtn: "Accept",
          acceptNecessaryBtn: "Decline",
          showPreferencesBtn: "Manage preferences",
        },
        preferencesModal: {
          title: "Manage cookie preferences",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Decline all",
          savePreferencesBtn: "Save preferences",
          closeIconLabel: "Close",
          sections: [
            {
              title: "Strictly necessary",
              description:
                "These cookies are required for the site to function and cannot be turned off.",
              linkedCategory: "necessary",
            },
            {
              title: "Analytics & advertising",
              description:
                "These cookies power analytics, session insights, and advertising attribution. They load only if you accept.",
              linkedCategory: TRACKING_CATEGORY,
            },
          ],
        },
      },
    },
  },
}
